


import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

import { Result } from '../../../models/result-viewmodel';

import LinkDirective from '@/shared/directives/link-directive';
import LinksDirective from '@/shared/directives/links-directive';

@Component({
    computed: {
        ...mapGetters(['config'])
    },
    directives: {
        LinkDirective,
        LinksDirective
    }
})
export default class ResultComponent extends Vue {
    @Prop() result!: Result;
}
